import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-data-placeholder',
  templateUrl: './data-placeholder.component.html',
  styleUrls: ['./data-placeholder.component.scss'],
})
export class DataPlaceholderComponent {
  @Input() placeholderText?: string;
  @Input() icon?: string;
}
